module.exports = __webpack_public_path__ + "img/callingImg.83c0714c.png";